////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const headerCarousel = {
	[ActionsTypes.HEADER_CAROUSEL_STORE_ACTIVE_VALUE]: (state, payload) =>
		update(state, {
			headerCarousel: {
				active: {
					$set: payload.activeValue,
				},
			},
		}),
}

export default headerCarousel
